module.exports = __webpack_public_path__ + "static/img/team_3.02141e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team_3.png
// module id = ck4y
// module chunks = 1